var _path, _mask, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddtexthover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 7.13043C1 5.91329 1.93511 5 3 5H29C30.0649 5 31 5.91329 31 7.13043V24.8696C31 26.0867 30.0649 27 29 27H3C1.93511 27 1 26.0867 1 24.8696V7.13043Z",
    stroke: "#FEFEFE",
    strokeWidth: 2
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_8163_13504",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 18C4 17.4477 4.44772 17 5 17H22C22.5523 17 23 17.4477 23 18C23 18.5523 22.5523 19 22 19H5C4.44771 19 4 18.5523 4 18Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 22C4 21.4477 4.44772 21 5 21H12C12.5523 21 13 21.4477 13 22C13 22.5523 12.5523 23 12 23H5C4.44772 23 4 22.5523 4 22Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 15C3.34315 15 2 16.3431 2 18H6C6 18.5523 5.55228 19 5 19V15ZM22 15H5V19H22V15ZM25 18C25 16.3431 23.6569 15 22 15V19C21.4477 19 21 18.5523 21 18H25ZM22 21C23.6569 21 25 19.6569 25 18H21C21 17.4477 21.4477 17 22 17V21ZM5 21H22V17H5V21ZM2 18C2 19.6569 3.34314 21 5 21V17C5.55229 17 6 17.4477 6 18H2ZM5 19C3.34315 19 2 20.3431 2 22H6C6 22.5523 5.55229 23 5 23V19ZM12 19H5V23H12V19ZM15 22C15 20.3431 13.6569 19 12 19V23C11.4477 23 11 22.5523 11 22H15ZM12 25C13.6569 25 15 23.6569 15 22H11C11 21.4477 11.4477 21 12 21V25ZM5 25H12V21H5V25ZM2 22C2 23.6569 3.34314 25 5 25V21C5.55229 21 6 21.4477 6 22H2Z",
    fill: "#FEFEFE",
    mask: "url(#path-2-inside-1_8163_13504)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddtexthover);
export default __webpack_public_path__ + "static/media/addtexthover.36d10650.svg";
export { ForwardRef as ReactComponent };var _path, _mask, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddtexthover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 7.13043C1 5.91329 1.93511 5 3 5H29C30.0649 5 31 5.91329 31 7.13043V24.8696C31 26.0867 30.0649 27 29 27H3C1.93511 27 1 26.0867 1 24.8696V7.13043Z",
    stroke: "#FEFEFE",
    strokeWidth: 2
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_8163_13504",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 18C4 17.4477 4.44772 17 5 17H22C22.5523 17 23 17.4477 23 18C23 18.5523 22.5523 19 22 19H5C4.44771 19 4 18.5523 4 18Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 22C4 21.4477 4.44772 21 5 21H12C12.5523 21 13 21.4477 13 22C13 22.5523 12.5523 23 12 23H5C4.44772 23 4 22.5523 4 22Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 15C3.34315 15 2 16.3431 2 18H6C6 18.5523 5.55228 19 5 19V15ZM22 15H5V19H22V15ZM25 18C25 16.3431 23.6569 15 22 15V19C21.4477 19 21 18.5523 21 18H25ZM22 21C23.6569 21 25 19.6569 25 18H21C21 17.4477 21.4477 17 22 17V21ZM5 21H22V17H5V21ZM2 18C2 19.6569 3.34314 21 5 21V17C5.55229 17 6 17.4477 6 18H2ZM5 19C3.34315 19 2 20.3431 2 22H6C6 22.5523 5.55229 23 5 23V19ZM12 19H5V23H12V19ZM15 22C15 20.3431 13.6569 19 12 19V23C11.4477 23 11 22.5523 11 22H15ZM12 25C13.6569 25 15 23.6569 15 22H11C11 21.4477 11.4477 21 12 21V25ZM5 25H12V21H5V25ZM2 22C2 23.6569 3.34314 25 5 25V21C5.55229 21 6 21.4477 6 22H2Z",
    fill: "#FEFEFE",
    mask: "url(#path-2-inside-1_8163_13504)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddtexthover);
export default __webpack_public_path__ + "static/media/addtexthover.36d10650.svg";
export { ForwardRef as ReactComponent };